import { render, staticRenderFns } from "./TopicPostList.vue?vue&type=template&id=00fd8150"
import script from "./TopicPostList.vue?vue&type=script&lang=ts"
export * from "./TopicPostList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports